/**
 * Component to Add or Edit a single user
 */
import * as React from 'react';
import { Card, Row, Col, Input, Button, Select, Icon, message, Breadcrumb, Radio } from 'antd';
import { IcommonProps } from '../common/props';
import '../../css/UserAddEdit.scss';
import Util from '../common/utils';
import Auth from '../common/auth';
import service from '../../service/apolloclient.service';
import { Tasks } from '../common/auth';
import { MSGDISPLAYTIME } from '../common/constants';
import { VIEWSTATE } from '../common/constants';
import { staticProperties, STATICKEYS } from '../common/staticProperties';
import LocalStorage from '../../service/localstorage';
import strings from '../../eyeguide-localization/user/string.user.addedit';
import Token from '../common/token';
import UnAuthorized from '../errorPages/unauthorized';

const storage = new LocalStorage();
const Option = Select.Option;
const RadioGroup = Radio.Group;
const EVENT = {
    ADDUSER: '/user/add/',
    EDITUSER: '/user/edit/',
};

// const CheckboxGroup = Checkbox.Group;

/**
 * Property definition
 */
interface IUserProps extends IcommonProps {
    save: any;
    cancel: any;
    navigationFrom: any;
    location: any;
    match: any;
}

/**
 * State definition
 */
interface IUserState {
    classesWithErr: string;
    classesWithoutErr: string;
    errorusername: boolean;
    errorfirstname: boolean;
    errorlastname: boolean;
    errorrole: boolean;
    errorOrg: boolean;
    erroremail: boolean;
    errorphone: boolean;
    role: any;
    showOrg: boolean;
    orgElems: any;
    selectedOrgs: any;
    showUserCheck: boolean;
    userCheckType: string;
    userCheckColor: string;
    username: string;
    firstname: string;
    lastname: string;
    email: any;
    phone: string;
    user: any;
    loggedInUid: string;
    unAuth: boolean;
    candeletetest: number;
    canaddprofile: number;
}

export default class UserAddEdit extends React.Component<IUserProps, IUserState> {
    allOrgIds: any = [];
    constructor(props: IUserProps) {
        super(props);
        this.state = {
            classesWithErr: 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorusername: false,
            errorfirstname: false,
            errorlastname: false,
            errorrole: false,
            errorOrg: false,
            erroremail: false,
            errorphone: false,
            role: '',
            showOrg: false,
            orgElems: [],
            selectedOrgs: [],
            showUserCheck: false,
            userCheckType: '',
            userCheckColor: '',
            username: '',
            firstname: '',
            lastname: '',
            email: '',
            phone: '',
            user: [],
            loggedInUid: Token.decodeToken().uid,
            unAuth: false,
            candeletetest: 1,
            canaddprofile: 1,
        };

        this.validateUsername = this.validateUsername.bind(this);
    }

    async componentDidMount() {
        Util.resetScroll();
        staticProperties.set(STATICKEYS.selectedKey, VIEWSTATE.USER);
        staticProperties.set(STATICKEYS.selectedRoster, '');
        if (this.props.location.pathname.startsWith(EVENT.EDITUSER)) {
            await this.getUserToEdit(this.props.match.params.userid);
        }
        let showOrg: boolean =
            !(this.state.user instanceof Array) && this.state.user.length !== 0
                ? Auth.canPerformTask(this.state.user.roleid, Tasks.hasAllOrgs)
                    ? false
                    : true
                : false;
        console.log('user', this.state.user);
        let ser = new service();
        let res: any = await ser.getSubOrganizations(2, storage.getSelectedOrgPrimary());
        this.allOrgIds = res.map((e) => e.organizationid);
        let orgElems: any = this.getOrganizationElements(res);
        let uncheckedOrgs: any = await ser.getUncheckedOrgs(this.state.user.uid);

        console.log('unchecked', uncheckedOrgs);
        let defOrgIds: any = [];
        if (showOrg) {
            this.state.user.organizations.forEach((e: any) => {
                defOrgIds.push(e.organizationid);
            });
        } else if (this.state.user.length !== 0) {
            res.forEach((e: any) => {
                let x = uncheckedOrgs.filter((org) => e.organizationid === org.organizationid);
                if (x.length === 0) {
                    defOrgIds.push(e.organizationid);
                }
            });
        }
        console.log('default orgs', defOrgIds);
        this.setState({
            orgElems: orgElems,
            role: this.state.user.roleid,
            showOrg: showOrg,
            selectedOrgs: defOrgIds,
            username: this.state.user.username,
            firstname: this.state.user.firstname,
            lastname: this.state.user.lastname,
            email: this.state.user.email,
            phone: this.state.user.phone,
            candeletetest:
                this.state.user.candeletetest != null
                    ? this.state.user.candeletetest
                    : this.state.candeletetest,
            canaddprofile:
                this.state.user.canaddprofile != null
                    ? this.state.user.canaddprofile
                    : this.state.canaddprofile,
        });

        console.log('componentDidUpdate');
    }

    render() {
        console.log('this.state', this.state);
        // if (this.props.user === '') { // if user is empty, call is from Add User
        //     this.resetControls();
        // }
        let roles: any = [];
        let allRoles: any = Auth.getUserRoles();
        Object.keys(allRoles).forEach((value: any, index: any) => {
            roles.push({
                name: Util.cascadeStringCase(value.toString().replace(new RegExp('_', 'g'), ' ')),
                id: allRoles[value],
            });
        });
        if (this.state.unAuth) {
            return <UnAuthorized />;
        }
        return (
            <div className="UserAddEdit">
                <Card>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <a href="/dashboard">{strings.lsHomeTxt}</a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <a href="/user">{strings.lsUsersTxt}</a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            {this.state.user instanceof Array && this.state.user.length === 0
                                ? strings.lsAddTxt
                                : strings.lsEditTxt}
                        </Breadcrumb.Item>
                    </Breadcrumb>
                    <br />
                    <h3>
                        {' '}
                        {this.state.user instanceof Array && this.state.user.length === 0
                            ? strings.lsAddUsrTxt
                            : strings.lsEditUsrTxt}{' '}
                    </h3>
                </Card>
                <Card bordered={false} style={{ margin: '24px 16px' }}>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span>
                                    {' '}
                                    {strings.lsUsrNameTxt}
                                    <span className="labelReq"> * </span>:
                                </span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input
                                value={this.state.username}
                                onChange={(val) => {
                                    let username = val.target.value
                                        .toLowerCase()
                                        .replace(/\s/g, '');
                                    this.setState({ username });
                                }}
                                className={
                                    this.state.errorusername
                                        ? this.state.classesWithErr
                                        : this.state.classesWithoutErr
                                }
                                placeholder="e.g. jjohnson"
                                onBlur={() => this.validateUsername()}
                                disabled={
                                    this.state.user instanceof Array && this.state.user.length === 0
                                        ? false
                                        : true
                                }
                                autoFocus={true}
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={5} xl={4}>
                            {this.state.showUserCheck ? (
                                <div>
                                    <Col xs={1} sm={1} md={2} lg={4} xl={5}>
                                        <Icon
                                            className="iconStyle"
                                            style={{
                                                paddingTop: '5px',
                                                color: this.state.userCheckColor,
                                                fontSize: '19px',
                                            }}
                                            type={this.state.userCheckType}
                                        />{' '}
                                    </Col>
                                    <Col xs={1} sm={1} md={2} lg={20} xl={19}>
                                        {this.state.userCheckColor === 'red' ? (
                                            <span className="hyphenate">
                                                {' '}
                                                {strings.lsUsrAlreadyExistTxt}
                                            </span>
                                        ) : (
                                            ''
                                        )}
                                    </Col>
                                </div>
                            ) : (
                                ''
                            )}
                        </Col>
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span>
                                    {' '}
                                    {strings.lsFNameTxt}
                                    <span className="labelReq"> * </span>:
                                </span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input
                                value={this.state.firstname}
                                onChange={(val) => this.setState({ firstname: val.target.value })}
                                className={
                                    this.state.errorfirstname
                                        ? this.state.classesWithErr
                                        : this.state.classesWithoutErr
                                }
                                placeholder="e.g. Johnny"
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span>
                                    {' '}
                                    {strings.lsLNameTxt}
                                    <span className="labelReq"> * </span>:
                                </span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input
                                value={this.state.lastname}
                                onChange={(val) => this.setState({ lastname: val.target.value })}
                                className={
                                    this.state.errorlastname
                                        ? this.state.classesWithErr
                                        : this.state.classesWithoutErr
                                }
                                placeholder="eg Thomas"
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span>
                                    {' '}
                                    {strings.lsEmailTxt}
                                    <span className="labelReq"> * </span>:
                                </span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input
                                value={this.state.email}
                                onChange={(val) => this.setState({ email: val.target.value })}
                                className={
                                    this.state.erroremail
                                        ? this.state.classesWithErr
                                        : this.state.classesWithoutErr
                                }
                                placeholder="eg johny.thomas@school.edu"
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span>
                                    {' '}
                                    {strings.lsMobilePhTxt}
                                    <span className="labelReq"> * </span>:
                                </span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Input
                                value={this.state.phone}
                                onChange={(val) => this.setState({ phone: val.target.value })}
                                className={
                                    this.state.errorphone
                                        ? this.state.classesWithErr
                                        : this.state.classesWithoutErr
                                }
                                placeholder="eg 0123-456-789"
                            />
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span>
                                    {strings.lsRoleTxt}
                                    <span className="labelReq"> * </span>:
                                </span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Select
                                value={this.state.role}
                                className={
                                    this.state.errorrole
                                        ? 'fill errorHighlightSel'
                                        : this.state.classesWithoutErr
                                }
                                onChange={(val) => {
                                    this.setState({
                                        role: val,
                                    });
                                    this.handleOrgListDisplay(val);
                                }}
                                placeholder="Select Role"
                                getPopupContainer={this.getContainer}
                            >
                                {roles.map((x: any) => (
                                    <Option key={x.id} value={x.id}>
                                        {x.name}
                                    </Option>
                                ))}
                            </Select>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span>
                                    {strings.lsOrgTxt}
                                    <span className="labelReq"> * </span>:
                                </span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <Select
                                mode="multiple"
                                style={{ width: '100%' }}
                                placeholder="Select Organization"
                                value={this.state.selectedOrgs}
                                className={
                                    this.state.errorOrg
                                        ? 'fill errorHighlightSel'
                                        : this.state.classesWithoutErr
                                }
                                onChange={(val) => {
                                    console.log('val', val);
                                    this.setState({ selectedOrgs: val });
                                }}
                                getPopupContainer={this.getContainer}
                                filterOption={(inputValue: string, option: any) =>
                                    option !== null && option !== undefined
                                        ? option.props.children
                                              .toUpperCase()
                                              .indexOf(inputValue.toUpperCase()) !== -1
                                        : ''
                                }
                            >
                                {this.state.orgElems}
                            </Select>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span>
                                    {strings.lsDeleteTestTxt}
                                    <span className="labelReq"> * </span>:
                                </span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <RadioGroup
                                className="labelFrame"
                                value={this.state.candeletetest}
                                onChange={(val) =>
                                    this.setState({ candeletetest: val.target.value })
                                }
                            >
                                <Radio defaultChecked={true} value={1}>
                                    {strings.lsAllowedTxt}
                                </Radio>
                                <Radio defaultChecked={false} value={0}>
                                    {strings.lsNotAllowedTxt}
                                </Radio>
                            </RadioGroup>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                    </Row>
                    <Row className="row">
                        <Col xs={1} sm={1} md={2} lg={5} xl={5} />
                        <Col xs={8} sm={8} md={5} lg={3} xl={3} className="labelFrame">
                            <div className="label">
                                <span>
                                    {strings.lsAddProfileTxt}
                                    <span className="labelReq"> * </span>:
                                </span>
                            </div>
                        </Col>
                        <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                            <RadioGroup
                                className="labelFrame"
                                value={this.state.canaddprofile}
                                onChange={(val) =>
                                    this.setState({ canaddprofile: val.target.value })
                                }
                            >
                                <Radio defaultChecked={true} value={1}>
                                    {strings.lsAllowedTxt}
                                </Radio>
                                <Radio defaultChecked={false} value={0}>
                                    {strings.lsNotAllowedTxt}
                                </Radio>
                            </RadioGroup>
                        </Col>
                        <Col xs={1} sm={1} md={2} lg={6} xl={4} />
                    </Row>
                    <Row>
                        <Col span={12} style={{ padding: '10px' }}>
                            <div className="buttonRight">
                                <Button
                                    onClick={(e) => {
                                        if (
                                            this.state.user instanceof Array &&
                                            this.state.user.length === 0
                                        ) {
                                            this.processUser(this.getUserObj(), 1, ''); // 1 for add
                                        } else {
                                            this.processUser(
                                                this.getUserObj(),
                                                0,
                                                this.state.user.uid
                                            ); // 0 for save
                                        }
                                    }}
                                    type="primary"
                                    style={{ width: '100%' }}
                                >
                                    {this.state.user instanceof Array &&
                                    this.state.user.length === 0
                                        ? strings.lsAddTxt
                                        : strings.lsSaveTxt}
                                </Button>
                            </div>
                        </Col>
                        <Col span={12} style={{ padding: '10px' }}>
                            <div className="buttonLeft">
                                <Button
                                    onClick={(e) => history.back()}
                                    type="danger"
                                    style={{ width: '100%' }}
                                >
                                    {strings.lsCancelTxt}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Card>
            </div>
        );
    }

    /**
     * Returns user object in json format
     * to be sent to server for processing
     */
    private getUserObj(): any {
        if (this.validateInput() && this.state.userCheckColor !== 'red') {
            let inputUser: any = {
                username: this.state.username !== null ? this.state.username.trim() : '',
                firstname: this.state.firstname !== null ? this.state.firstname.trim() : '',
                lastname: this.state.lastname !== null ? this.state.lastname.trim() : '',
                email: this.state.email !== null ? this.state.email.trim() : '',
                phone: this.state.phone != null ? this.state.phone.trim() : '',
                roleid: this.state.role !== null ? this.state.role : '',
                organizations: this.state.selectedOrgs,
                candeletetest: this.state.candeletetest,
                canaddprofile: this.state.canaddprofile,
            };
            console.log('inputOrg', inputUser);
            return inputUser;
        } else {
            return '';
        }
    }

    /**
     * Validate input values provided by the user before submitting to server
     */
    private validateInput(): boolean {
        let isValid: boolean = true;
        let errorusername: boolean = false;
        let errorfirstname: boolean = false;
        let errorlastname: boolean = false;
        let errorrole: boolean = false;
        let errorOrg: boolean = false;
        let erroremail: boolean = false;
        let errorphone: boolean = false;
        this.state.username !== null &&
        (this.state.username === undefined || this.state.username.trim() === '')
            ? (errorusername = true)
            : (errorusername = false);
        this.state.firstname !== null &&
        (this.state.firstname === undefined || this.state.firstname.trim() === '')
            ? (errorfirstname = true)
            : (errorfirstname = false);
        this.state.lastname !== null &&
        (this.state.lastname === undefined || this.state.lastname.trim() === '')
            ? (errorlastname = true)
            : (errorlastname = false);
        this.state.role !== null && (this.state.role === '' || this.state.role === undefined)
            ? (errorrole = true)
            : (errorrole = false);
        this.state.email !== null &&
        (this.state.email === undefined || this.state.email.trim() === '')
            ? (erroremail = true)
            : (erroremail = false);
        this.state.phone !== null &&
        (this.state.phone === undefined || this.state.phone.trim() === '')
            ? (errorphone = true)
            : (errorphone = false);
        // if (this.state.showOrg) {
        this.state.selectedOrgs !== null &&
        (this.state.selectedOrgs === '' ||
            this.state.selectedOrgs === undefined ||
            this.state.selectedOrgs.length === 0)
            ? (errorOrg = true)
            : (errorOrg = false);
        // }
        erroremail = erroremail ? erroremail : !Util.validateEmail(this.state.email);
        if (
            errorusername ||
            errorfirstname ||
            errorlastname ||
            errorrole ||
            erroremail ||
            errorphone ||
            errorOrg
        ) {
            isValid = false;
        }
        this.setState({
            errorusername,
            errorfirstname,
            errorlastname,
            errorrole,
            erroremail,
            errorphone,
            errorOrg,
        });
        return isValid;
    }

    // /**
    //  * Reset all control values
    //  */
    // private resetControls() {
    //     this.firstname = React.createRef();
    //     this.lastname = React.createRef();
    //     this.email = React.createRef();
    //     this.username = React.createRef();
    // }

    /**
     * Returns TSX Element (Option) to fill organization dropdown.
     * @param orgs List of organizations
     */
    private getOrganizationElements(orgs: any) {
        let orgElements: any = [];
        console.log('orgs', orgs);
        orgs.forEach((e: any) => {
            orgElements.push(
                <Option key={e.organizationid} value={e.organizationid}>
                    {e.name}
                </Option>
            );
        });
        return orgElements;
    }

    /**
     * Handles display change for Organization while creating user when user selects role.
     * If role is assigned all organizations, Organization drop down is not dispalyed
     * @param roleid Role id
     */
    private handleOrgListDisplay(roleid: any) {
        console.log('roleid', roleid);
        this.setState({
            showOrg: Auth.canPerformTask(roleid, Tasks.hasAllOrgs) ? false : true,
            selectedOrgs: roleid === 6 ? [...this.allOrgIds] : [],
        });
    }

    /**
     * Validates the username provided by user while creating user,
     * by calling the server
     */
    private async validateUsername() {
        console.log('validate', this.state.username);
        let ser = new service();
        let response: any;
        if (
            this.state.username !== null &&
            this.state.username !== undefined &&
            this.state.username.length > 0
        ) {
            response = await ser.verifyUsername(this.state.username);
            console.log('response', response);
            if (response.status === 0) {
                // success
                this.setState({
                    showUserCheck: true,
                    userCheckType: 'check-circle', // 'check-circle'
                    userCheckColor: '#4ddb33b0', // '#4ddb33b0'
                });
            } else {
                this.setState({
                    showUserCheck: true,
                    userCheckType: 'close-circle', // 'check-circle'
                    userCheckColor: 'red', // '#4ddb33b0'
                });
            }
        }
    }

    /**
     * sets the container element for dropdown menu
     */
    private getContainer = (triggernode) => triggernode.parentNode;

    private async getUserToEdit(id: any) {
        let ser = new service();
        let resp = await ser.getUser(id);
        if (resp.status === 0 && resp.message === 'NOT FOUND') {
            this.setState({
                unAuth: true,
                user: [],
            });
        } else {
            this.setState({ user: resp });
            console.log('UserToEdit', resp);
        }
    }

    /**
     * Handles User add / update as per the event sent.
     * @param user User Object to Add/Update
     * @param event Event to process. 1 - Add else Update
     * @param uid User id
     */
    private async processUser(user: any, event: number, uid: string) {
        console.log('process User');
        if (user !== '') {
            let ser = new service();
            if (event === 1) {
                let userResponse: any = await ser.addeditUser(
                    user,
                    '',
                    storage.getSelectedOrgPrimary()
                );
                message.success(strings.lsUsrAddSuccessTxt, MSGDISPLAYTIME);
                console.log('userResponse', userResponse);
            } else {
                console.log(uid);
                let userResponse: any = await ser.addeditUser(
                    user,
                    uid,
                    storage.getSelectedOrgPrimary()
                );
                message.success(strings.lsUsrUpdateSuccessTxt, MSGDISPLAYTIME);
                if (uid === this.state.loggedInUid) {
                    storage.setFirstName(user.firstname);
                    storage.setLastName(user.lastname);
                }
                console.log('userResponse', userResponse);
            }
            history.back();
        } else {
            // do not do anything
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/user/UserAddEdit.tsx